import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface UserTypeRecord {
    id: number;
    name: string;
}

// Authoritative id <-> name mapping for roles, sourced from the backend's user_type
// table. Row IDs are NOT guaranteed to follow any fixed order (seeding history,
// migrations, and manual edits all affect them) — never hardcode this mapping.
@Injectable({
    providedIn: "root",
})
export class UserTypeService {
    private apiUrl = `${environment.apiUrl}/api/v1/usertype`;
    private userTypes$?: Observable<UserTypeRecord[]>;

    constructor(private http: HttpClient) {}

    list(): Observable<UserTypeRecord[]> {
        if (!this.userTypes$) {
            this.userTypes$ = this.http.get<UserTypeRecord[]>(`${this.apiUrl}/list`).pipe(
                shareReplay({ bufferSize: 1, refCount: false })
            );
        }
        return this.userTypes$;
    }
}
